/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_INVOICE_PDF } from "../graphql/getInvoicePdf.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetInvoicePdfTypeMethods extends IPluginMethodMap {
  getInvoicePdf(args: any): Promise<any>;
}

export class GetInvoicePdfService implements IAgentPlugin {
  readonly methods: IGetInvoicePdfTypeMethods;

  constructor() {
    this.methods = {
      getInvoicePdf: this.getInvoicePdf.bind(this),
    };
  }

  async getInvoicePdf(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_INVOICE_PDF,
          variables: {
            filter: {
              _id: args,
            },
          },
          fetchPolicy: "network-only",
        });

        if (
          res?.data?.getInvoicePDF?.pdf &&
          is.existy(res?.data?.getInvoicePDF?.pdf)
        ) {
          return res?.data?.getInvoicePDF?.pdf;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
